import React, { useState } from "react";
import API_BASE_URL from "./config/api";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Modal from "./Modal";
// import FloatingImage from "./assests/AIicon.png";
import FloatingAIButton from "./components/FloatingAIButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import "./ContactUs.css";

function ContactUs() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formValues = {
      name: formData.get("name"),
      email: formData.get("email"),
      phoneNumber: formData.get("phoneNumber"),
      state: formData.get("state"),
      city: formData.get("city"),
      adventureType: formData.get("adventureType"),
      message: formData.get("message"),
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formValues),
      redirect: "follow",
    };

    setIsLoading(true);

    fetch(`${API_BASE_URL}/contact`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        setIsEmailSent(true);
        setIsLoading(false);
        setTimeout(() => {
          setIsEmailSent(false);
          e.target.reset();
        }, 5000);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const contactDetails = [
    {
      icon: faEnvelope,
      title: "Email",
      content: "contact@trippro.in",
      link: "mailto:contact@trippro.in",
    },
    {
      icon: faPhone,
      title: "Phone",
      content: "+91 92113 76008",
      link: "tel:+919211376008",
    },
    {
      icon: faMapMarkerAlt,
      title: "Address",
      content: "Trippro, 104, Ajay Park, Najafgarh, Delhi",
      link: "https://maps.google.com/?q=Trippro+Najafgarh+Delhi",
    },
  ];

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      {/* <div className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <h1>Get in Touch</h1>
          <p>We'd love to hear from you. Let's plan your next adventure.</p>
        </div>
      </div> */}

      <div className="contact-container">

        {/* Contact Info Cards */}
        <div className="contact-info-section">
          <h2 className="contact-intro-title">Our Contact Information</h2>
          <div className="contact-cards-grid">
            {contactDetails.map((item, index) => (
              <div className="contact-page-card" key={index}>
                <div className="contact-icon-wrapper">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <h3>{item.title}</h3>
                <a
                  href={item.link}
                  className="contact-page-card-text"
                  target={item.title === "Address" ? "_blank" : "_self"}
                  rel="noreferrer"
                >
                  {item.content}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Split Form Section */}
        <div className="contact-form-section">
          <div className="form-visual">
            <div className="form-visual-overlay"></div>
            <div className="form-visual-text">
              <h2>Book a Tour</h2>
              <p>Ready to start your journey? Fill out the form and our experts will get back to you shortly.</p>
            </div>
          </div>

          <div className="form-container">
            <div className="form-header">
              <h3>Send us a Message</h3>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group form-row">
                <input type="text" name="name" className="styled-input" placeholder="Your Name" required />
                <input type="email" name="email" className="styled-input" placeholder="Your Email" required />
              </div>

              <div className="form-group form-row">
                <input type="text" name="phoneNumber" className="styled-input" placeholder="Phone Number" required />
                <input type="text" name="adventureType" className="styled-input" placeholder="Adventure Type (e.g. Hiking)" required />
              </div>

              <div className="form-group form-row">
                <input type="text" name="city" className="styled-input" placeholder="City" required />
                <input type="text" name="state" className="styled-input" placeholder="State" required />
              </div>

              <div className="form-group">
                <textarea name="message" className="styled-textarea" placeholder="Tell us about your trip plans..." required></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? <div className="spinner"></div> : "Send Message"}
              </button>

              {isEmailSent && (
                <div className="success-message">
                  Message sent successfully! We'll be in touch soon.
                </div>
              )}
            </form>
          </div>
        </div>

      </div>

      {/* Floating Button */}
      {/* Floating Button */}
      <FloatingAIButton onClick={openModal} />

      {isModalOpen && <Modal closeModal={closeModal} />}

      <Footer />
    </>
  );
}

export default ContactUs;
